<template>
	<span ref="numberGrow" :data-time="time" class="number-grow" :data-value="value"></span>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
 data(){
	 return {} 
 },
 props:{
  time: {
   type: Number,
   default: 2
  },
  value: {
   type: Number,
   default: 0
  }
 },
 computed:{
 	...Vuex.mapState('supervisor', ['destroy']),
 },
 watch: {
    value: {
      handler(newValue, oldValue) {
         this.value = newValue;
         this.destroy.flag = false
		this.$nextTick(function(){
			this.destroy.flag = true
		})
		 this.$forceUpdate();
      },
      deep: true
    }
 },
 methods: {
  numberGrow (ele) {
   let _this = this;
   let step = (_this.value * 10) / (_this.time * 1000);
   let start = 0;
   let t = setInterval(function () {
    start += step
    if (start > _this.value) {
     clearInterval(t)
     start = _this.value
     t = null
    }
    ele.innerHTML = parseInt(start);
   }, 1)
  }
 },
 mounted () {
  this.numberGrow(this.$refs.numberGrow)
 }
}
</script>
